export const CALL_COST_PER_MINUTE_USD = 0.25;
